import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../../fire";
import FullScreenLoadingSpinner from "../../components/FullScreenLoadingSpinner/FullScreenLoadingSpinner";
import { useUserRole } from "../../store/UserRoleContext";

const AdminFlowLayout = () => {
  const navigate = useNavigate();
  const [user, loading] = useAuthState(auth);
  const { role, isInitialLoading } = useUserRole();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/login");
      return;
    }
    // Only bounce a CONFIRMED non-admin. A null role means "not yet known"
    // (still resolving, or a transient role-fetch error) — never redirect on
    // that, otherwise a hiccup in the lookup kicks an admin off their page.
    if (role !== null && role !== "Admin") {
      navigate("/");
    }
  }, [user, loading, role, navigate]);

  // Wait while auth resolves or the role is still being determined (cold start).
  if (loading || isInitialLoading) return <FullScreenLoadingSpinner />;

  // Known non-admin: render nothing while the redirect effect runs.
  if (role !== "Admin") return null;

  return <Outlet />;
};

export default AdminFlowLayout;
